import { loadState } from '@/utils/localStorage'
import {
  ADD_PATIENT_ADDRESS_API,
  DELETE_PATIENT_ADDRESS_API,
  EDIT_PATIENT_ADDRESS_API,
  GET_LOYALTY_POINTS_API,
  GET_PATIENT_ADDRESS_API,
  PATIENT_FAMILY_UPDATE,
  PATIENT_SEARCH_API,
} from './apiConstants'
import { consumerRequest } from './request'
import { dispatch, useSelector } from '@/lib/store'
import { updateUserProfile, updateAvailablePoints } from '@/lib/reducers/userReducer'
import { updateLoginData } from '@/lib/reducers/loginReducer'

import { getAllPrimaryProfiles, isEmpty } from '@/utils/commonFunc'
import { askUserToSelectPatient } from '@/lib/reducers/patientReducer'

const PATIENT_HELPER = () => {
  const loggedInMobileNumber = loadState('ctxVal') || null

  const cityState = useSelector((state) => state.city) || {}
  const loginState = useSelector((state) => state.login) || {}
  const patientState = useSelector((state) => state.patient) || {}

  const handleGetUserDetails = async () => {
    if (isEmpty(loggedInMobileNumber)) return

    const apiRes: any = await consumerRequest(PATIENT_SEARCH_API, 'post', {
      phoneNumber: loggedInMobileNumber,
    })

    const members = Array.isArray(apiRes?.data) ? apiRes.data : []

    const primaryProfiles = getAllPrimaryProfiles(members) || []

    const selfUser = members.find(
      (item: any) =>
        item.relation === 'SELF' && item.phoneNumber === loggedInMobileNumber
    )
    const phoneMatchUser = members.find(
      (item: any) => item.phoneNumber === loggedInMobileNumber
    )

    const userObj =
      primaryProfiles?.[0] || selfUser || phoneMatchUser || members?.[0] || {}

    dispatch(updateUserProfile({ ...userObj, membersList: members }))

    if (Object.keys(userObj).length > 0) {
      const loyaltyRes: any = await consumerRequest(GET_LOYALTY_POINTS_API, 'post', {
        cityUuid: cityState?.currentCityObj?.uuid,
        phoneNumber: loggedInMobileNumber,
      })
      const availablePoints = loyaltyRes?.status === true
        ? Number(loyaltyRes?.data?.RSP_MSG?.AvailablePoints) || 0
        : 0

      dispatch(
        updateLoginData({
          ...loginState,
          isUserLoggedIn: true,
          loginModalIsOpen: false,
        })
      )
      dispatch(updateAvailablePoints(availablePoints))
    }
    if (
      !isEmpty(members) &&
      (isEmpty(primaryProfiles) || primaryProfiles?.length > 1)
    )
      dispatch(
        askUserToSelectPatient({
          ...patientState,
          selectedTest: {},
          selectPatientModalIsOpen: true,
          loginFlowPrimarySelection: true,
        })
      )
  }

  const handleGetUserAddressList = async () => {
    const formData = {
      phoneNumber: loggedInMobileNumber,
    }

    const apiResponse: any = await consumerRequest(
      GET_PATIENT_ADDRESS_API,
      'post',
      formData
    )
    if (apiResponse?.status === true) {
      return apiResponse
    } else {
      console.error('Failed to fetch address', apiResponse?.message)
      return apiResponse
    }
  }

  const handleAddUserAddress = async (userFormData: any) => {
    const formData = {
      addressType: userFormData?.addressType,
      addressTag: userFormData?.addressTag,
      area: '',
      pincode: userFormData?.pinCode,
      mapAddress: userFormData?.mapAddress,
      city: userFormData?.city,
      cityUuid: userFormData?.cityUuid,
      houseNo: userFormData?.houseNo,
      floor: userFormData?.floorNo,
      landmark: userFormData?.landmark,
      phoneNumber: loggedInMobileNumber,
      latitude: userFormData.latitude,
      longitude: userFormData.longitude,
      locality: userFormData.locality,
    }

    const apiResponse: any = await consumerRequest(
      ADD_PATIENT_ADDRESS_API,
      'post',
      formData
    )
    if (apiResponse?.status === true) {
      return apiResponse
    } else {
      console.error('Failed to add address', apiResponse)
      return apiResponse
    }
  }

  const handleEditUserAddress = async (uuid: string, userFormData: any) => {
    const formData = {
      addressType: userFormData?.addressType,
      addressTag: userFormData?.addressTag,
      area: '',
      pincode: userFormData?.pinCode,
      mapAddress: userFormData?.mapAddress,
      city: userFormData?.city,
      cityUuid: userFormData?.cityUuid,
      houseNo: userFormData?.houseNo,
      floor: userFormData?.floorNo,
      landmark: userFormData?.landmark,
      phoneNumber: loggedInMobileNumber,
      latitude: userFormData.latitude,
      longitude: userFormData.longitude,
      locality: userFormData.locality,
      uuid: uuid,
    }
    const apiResponse: any = await consumerRequest(
      EDIT_PATIENT_ADDRESS_API,
      'post',
      formData
    )
    if (apiResponse?.status === true) {
      return apiResponse
    } else {
      console.error('Failed to add address', apiResponse)
      return apiResponse
    }
  }

  const handleRemoveUserAddress = async (uuid: string) => {
    const FINAL_API_PATH = DELETE_PATIENT_ADDRESS_API + uuid
    const apiResponse: any = await consumerRequest(FINAL_API_PATH, 'post')
    if (apiResponse?.status === true) {
      return apiResponse
    } else {
      console.error('Failed to delete address', apiResponse)
      return apiResponse
    }
  }

  const handleGetUsersLoyaltyPoints = async (phoneNumber: any) => {
    const formData = {
      cityUuid: cityState?.currentCityObj?.uuid,
      phoneNumber: phoneNumber,
    }
    const apiResponse: any = await consumerRequest(
      GET_LOYALTY_POINTS_API,
      'post',
      formData
    )
    if (apiResponse?.status === true) {
      return apiResponse
    } else {
      console.error('Failed to fetch loyalty points', apiResponse)
    }
  }

  const updatePrimaryPatient = async (formData: any) => {
    const apiResponse: any = await consumerRequest(
      PATIENT_FAMILY_UPDATE,
      'post',
      formData
    )
    if (apiResponse?.status === true) {
      return apiResponse
    } else {
      console.error('Failed to update primary member', apiResponse)
    }
  }

  return {
    handleGetUserDetails,
    handleAddUserAddress,
    handleGetUserAddressList,
    handleRemoveUserAddress,
    handleEditUserAddress,
    handleGetUsersLoyaltyPoints,
    updatePrimaryPatient,
  }
}

export default PATIENT_HELPER
